import React from 'react';
import PropTypes from 'prop-types';
import { isString } from 'lodash';
import cn from 'classnames';
import Hint from 'shared/components/Hint';
import ErrorMessage from 'shared/components/ErrorMessage';
import styles from './Checkbox.module.scss';

const Checkbox = ({
  label,
  labelSuffix,
  labelHint,
  labelHintIconClassName,
  value,
  error,
  className,
  fullWidth,
  linkUrl,
  onClick,
  inverse,
  ...props
}) => {
  const id = props.id || `${props.name || 'select'}-${Math.round(Math.random() * 10000)}`;
  const hasError = !!error;

  const handleClick = (event) => {
    event.preventDefault();
    onClick(event);
  };

  return (
    <>
      <div
        className={cn(
          styles.checkbox,
          className,
          {
            [styles.fullWidth]: fullWidth,
            [styles.error]: hasError,
            [styles.inverse]: inverse,
            error: hasError
          }
        )}
      >
        <input type="checkbox" id={id} readOnly checked={!!value} onClick={onClick} {...props} />
        {linkUrl && onClick ? (
          <label htmlFor={id}>
            <a href={linkUrl} onClick={handleClick}>
              {label}
              {labelSuffix && (
                <small>{`(${labelSuffix})`}</small>
              )}
              {labelHint && (
                <Hint iconClassName={labelHintIconClassName} tooltip={labelHint} />
              )}
            </a>
          </label>
        ) : (
          <label htmlFor={id}>
            {label}
            {labelSuffix && (
              <small>{`(${labelSuffix})`}</small>
            )}
            {labelHint && (
              <Hint iconClassName={labelHintIconClassName} tooltip={labelHint} />
            )}
          </label>
        )}
      </div>
      {isString(error) && <ErrorMessage className={styles.errorMessage}>{error}</ErrorMessage>}
    </>
  );
};

Checkbox.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  labelSuffix: PropTypes.string,
  labelHint: PropTypes.string,
  labelHintIconClassName: PropTypes.string,
  value: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
  linkUrl: PropTypes.string,
  onClick: PropTypes.func,
  inverse: PropTypes.bool,
};

Checkbox.defaultProps = {
  label: null,
  labelSuffix: null,
  labelHint: null,
  labelHintIconClassName: 'la la-question-circle',
  value: false,
  error: null,
  className: '',
  fullWidth: false,
  linkUrl: null,
  onClick: null,
  inverse: false,
};

export default Checkbox;
